import { Reducer } from 'react';
import {
  resetPassRequest,
  resetPassSuccess,
  resetPassFailure,
  forgotPassRequest,
  forgotPassSuccess,
  forgotPassFailure,
  permissionsRequest,
  permissionsSuccess,
  permissionsFailure,
} from '../user/user.reducers';
import {
  createZoneRequest, createZoneSuccess, createZoneFail,
  getZonesListStart,
  getZonesListSuccess,
  getZonesListSuccessNew,
  getZonesListFail,
  getFacilitiesListStart,
  getFacilitiesListSuccess,
  getFacilitiesListFail,
  getGroupTypesListStart,
  getGroupTypesListSuccess,
  getGroupTypesListFail,
  getGroupsListStart,
  getGroupsListSuccess,
  getGroupsListFail,
  getGroupsTreeListStart,
  resetImageValues,
  resetImageValuesFail,
  getGroupsTreeListSuccess,
  getGroupsTreeListFail,
  editGroupStart,
  editGroupSuccess,
  editGroupFail,
  deleteGroupStart,
  deleteGroupSuccess,
  deleteGroupFail,
  getLogicalReadersSuccess,
  getLogicalReadersFail,
  getLogicalReadersStart,
  deleteLogicalReaderStart,
  deleteLogicalReaderSuccess,
  deleteLogicalReaderFail,
  editLogicalReaderStart,
  editLogicalReaderSuccess,
  editLogicalReaderFail,
  getPolygonsStart,
  getPolygonsSuccess,
  getPolygonsFail,
  deletePolygonStart,
  deletePolygonSuccess,
  deletePolygonFail,
  editPolygonStart,
  editPolygonSuccess,
  editPolygonFail,
  createMapOriginRequest,
  createMapOriginSuccess,
  createMapOriginFail,
  createMapImageRequest,
  createMapImageSuccess,
  createMapImageFail,
  createMapImageImageRequest,
  createMapImageImageSuccess,
  createMapImageImageFail,
  resetMapReportValues,
} from '../facility/facility.reducers';
import createReducerUtil from '../../../utils/create-reducer';
import { IAction } from './i-action';
import {
  signInFailure,
  signInRequest,
  signInSuccess,
  logoutSuccess,
  getCurrentUserRequest,
  getCurrentUserSuccess,
  getCurrentUserFailure,
  getPickedUserRequest,
  getPickedUserSuccess,
  getPickedUserFailure,
  getUsersListFail,
  getUsersListStart,
  getUsersListSuccess,
  getRolesListFail,
  getRolesListRequest,
  getRolesListSuccess,
  timeZonesRequest,
  timeZonesSuccess,
  timeZonesFail,
  changeForgottenPasswordRequest,
  changeForgottenPasswordSuccess,
  changeForgottenPasswordFail,
  getAuthTypeRequest,
  getAuthTypeSuccess,
  getAuthTypeFailure,
} from '../user';
import { UserActionType } from '../user/user.enum';
import { IHelp, IState } from './state.interface';
import { TenantActionType } from '../tenants/tenant.enum';
import {
  getTenantsListStart,
  getTenantsListSuccess,
  getTenantsListFail,
  tenantRulesConfigRequest,
  tenantRulesConfigSuccess,
  tenantRulesConfigFail,
  tenantRulesConfigSchemaRequest,
  tenantRulesConfigSchemaSuccess,
  tenantRulesConfigSchemaFail,
  tenantRulesConfigSaveRequest,
  tenantRulesConfigSaveSuccess,
  tenantRulesConfigSaveFail,
  zonesSaveRequest,
  zonesSaveSuccess,
  zonesSaveFail,
  rulesConfigSchemaRequest,
  rulesConfigSchemaSuccess,
  rulesConfigSchemaFail,
  rulesConfigSuccess,
  rulesConfigSaveRequest,
  rulesConfigSaveSuccess,
  rulesConfigSaveFail,
  rulesPseudoCodeSuccess,
  tenantMermaidDiagramRequest,
  tenantMermaidDiagramSuccess,
  tenantMermaidDiagramFail,
  getTenantPropertiesListStart,
  getTenantPropertiesListSuccess,
  getTenantPropertiesListFail,
  getWrappedSchemaRequest,
  getWrappedSchemaSuccess,
  getWrappedSchemaFail,
  rulesPseudoCodeRequest,
  rulesPseudoCodeFail,
} from '../tenants/tenant.reducers';

import { FacilityActionType } from '../facility/facility.enum';
import {
  getAssetTypesListStart,
  getAssetTypesListSuccess,
  getAssetTypesListFail,
  getAssetTypePropertiesStart,
  getAssetTypePropertiesSuccess,
  getAssetTypePropertiesFail,
  editAssetTypePropertyStart,
  editAssetTypePropertySuccess,
  editAssetTypePropertyFail,
  editAssetStart,
  editAssetSuccess,
  editAssetFail,
  deleteAssetTypePropertyStart,
  deleteAssetTypePropertySuccess,
  deleteAssetTypePropertyFail,
  addAssetTypePropertyStart,
  addAssetTypePropertySuccess,
  addAssetTypePropertyFail,
  getAssetTypeFail,
  getAssetTypeStart,
  getAssetTypeSuccess,
} from '../asset/asset.reducers';
import { AssetActionType } from '../asset/asset.enum';
import { ReportActionType } from '../report/report.enum';
import {
  getReportsSuccess,
  getReportsFail,
  getReportsRequest,
  getReportSuccess,
  getReportFail,
  getReportRequest,
  getExecutedReportRequest,
  getExecutedReportSuccess,
  getExecutedReportFail,
  resetExecutedReport,
  executeReportFail,
  executeReportRequest,
  executeReportSuccess,
  removeColumnFail,
  removeColumnRequest,
  removeColumnSuccess,
  getReportsListFail,
  getReportsListRequest,
  getReportsListSuccess,
  getRegexRequest,
  getRegexSuccess,
  getRegexFail,
  prepareReportFailure,
  prepareReportRequest,
  prepareReportSuccess,
  copyReportFailure,
  getAllColumnsReportFail,
  getAllColumnsReportRequest,
  getAllColumnsReportSuccess,
  getCollectionsForReportFail,
  getCollectionsForReportRequest,
  getCollectionsForReportSuccess,
  getReportQuickRangesRequest,
  getReportQuickRangesSuccess,
  getReportQuickRangesFail,
  getListsForReportRequest,
  getListsForReportSuccess,
  getListsForReportFail,
  getReportSuggestionsRequest,
  getReportSuggestionsSuccess,
  getReportSuggestionsFail,
  createMapReportDefinitionRequest,
  createMapReportDefinitionSuccess,
  createMapReportDefinitionFail,
  createMapReportDefinitionDefaultRequest,
  createMapReportDefinitionDefaultSuccess,
  createMapReportDefinitionDefaultFail,
  createZoneForMapsRequest,
  createZoneForMapsSuccess,
  createZoneForMapsFail,
  createMapReportRequest,
  createMapReportSuccess,
  createMapReportFail,
  updateMapControsState,
  updateMapControsStateFail,
} from '../report';
import { DevicesActionType } from '../devices/devices.enum';
import { getDevicesListRequest, getDevicesListSuccess, getDevicesListFail } from '../devices';
import { HelpActionType } from '../help/help.enum';
import { RuleActionType } from '../rules/rules.enum';
import {
  getRulesAndStatementsFail,
  getRulesAndStatementsRequest,
  getRulesAndStatementsSuccess,
  getScheduleRulesFail,
  getScheduleRulesRequest,
  getScheduleRulesSuccess,
  getSystemConfigAndStatementsFail,
  getSystemConfigAndStatementsRequest,
  getSystemConfigAndStatementsSuccess,
  getTransformsAndStatementsFail,
  getTransformsAndStatementsRequest,
  getTransformsAndStatementsSuccess,
  updateRulesFail,
  updateRulesRequest,
  updateRulesSuccess,
  updateScheduledRulesFail,
  updateScheduledRulesRequest,
  updateScheduledRulesSuccess,
  updateSystemConfigFail,
  updateSystemConfigRequest,
  updateSystemConfigSuccess,
  updateTransformsFail,
  updateTransformsRequest,
  updateTransformsSuccess,
} from '../rules/rules.reducer';

export type AppReducer = Reducer<IState, IAction>;

const rootMapReducer = new Map<string, CallableFunction>();

rootMapReducer.set(UserActionType.AUTH_REQUEST, signInRequest);
rootMapReducer.set(UserActionType.AUTH_SUCCESS, signInSuccess);
rootMapReducer.set(UserActionType.AUTH_FAIL, signInFailure);

rootMapReducer.set(UserActionType.GET_AUTH_TYPE_REQUEST, getAuthTypeRequest);
rootMapReducer.set(UserActionType.GET_AUTH_TYPE_SUCCESS, getAuthTypeSuccess);
rootMapReducer.set(UserActionType.GET_AUTH_TYPE_FAIL, getAuthTypeFailure);

rootMapReducer.set(UserActionType.PERMISSION_REQUEST, permissionsRequest);
rootMapReducer.set(UserActionType.PERMISSION_SUCCESS, permissionsSuccess);
rootMapReducer.set(UserActionType.PERMISSION_FAIL, permissionsFailure);

rootMapReducer.set(UserActionType.RESET_PASS_REQUEST, resetPassRequest);
rootMapReducer.set(UserActionType.RESET_PASS_SUCCESS, resetPassSuccess);
rootMapReducer.set(UserActionType.RESET_PASS_FAIL, resetPassFailure);

rootMapReducer.set(UserActionType.FORGOT_PASSWORD_REQUEST, forgotPassRequest);
rootMapReducer.set(UserActionType.FORGOT_PASSWORD_SUCCESS, forgotPassSuccess);
rootMapReducer.set(UserActionType.FORGOT_PASSWORD_FAIL, forgotPassFailure);

rootMapReducer.set(UserActionType.GET_CURRENT_USER_REQUEST, getCurrentUserRequest);
rootMapReducer.set(UserActionType.GET_CURRENT_USER_SUCCESS, getCurrentUserSuccess);
rootMapReducer.set(UserActionType.GET_CURRENT_USER_FAIL, getCurrentUserFailure);

rootMapReducer.set(UserActionType.GET_PICKED_USER_REQUEST, getPickedUserRequest);
rootMapReducer.set(UserActionType.GET_PICKED_USER_SUCCESS, getPickedUserSuccess);
rootMapReducer.set(UserActionType.GET_PICKED_USER_FAIL, getPickedUserFailure);

rootMapReducer.set(UserActionType.GET_USERS_LIST_REQUEST, getUsersListStart);
rootMapReducer.set(UserActionType.GET_USERS_LIST_SUCCESS, getUsersListSuccess);
rootMapReducer.set(UserActionType.GET_USERS_LIST_FAIL, getUsersListFail);
rootMapReducer.set(UserActionType.GET_ROLES_LIST_REQUEST, getRolesListRequest);
rootMapReducer.set(UserActionType.GET_ROLES_LIST_SUCCESS, getRolesListSuccess);
rootMapReducer.set(UserActionType.GET_ROLES_LIST_FAIL, getRolesListFail);

rootMapReducer.set(UserActionType.GET_TIMEZONES_REQUEST, timeZonesRequest);
rootMapReducer.set(UserActionType.GET_TIMEZONES_SUCCESS, timeZonesSuccess);
rootMapReducer.set(UserActionType.GET_TIMEZONES_FAIL, timeZonesFail);

rootMapReducer.set(TenantActionType.GET_TENANTS_LIST_REQUEST, getTenantsListStart);
rootMapReducer.set(TenantActionType.GET_TENANTS_LIST_SUCCESS, getTenantsListSuccess);
rootMapReducer.set(TenantActionType.GET_TENANTS_LIST_FAIL, getTenantsListFail);

rootMapReducer.set(
  TenantActionType.GET_TENANT_PROPERTIES_LIST_REQUEST, getTenantPropertiesListStart,
);
rootMapReducer.set(
  TenantActionType.GET_TENANT_PROPERTIES_LIST_SUCCESS, getTenantPropertiesListSuccess,
);
rootMapReducer.set(
  TenantActionType.GET_TENANT_PROPERTIES_LIST_FAIL, getTenantPropertiesListFail,
);

rootMapReducer.set(
  TenantActionType.GET_SCHEMA_PROPERTY_REQUEST, getWrappedSchemaRequest,
);
rootMapReducer.set(
  TenantActionType.GET_SCHEMA_PROPERTY_SUCCESS, getWrappedSchemaSuccess,
);
rootMapReducer.set(
  TenantActionType.GET_SCHEMA_PROPERTY_FAIL, getWrappedSchemaFail,
);

rootMapReducer.set(FacilityActionType.GET_ZONES_LIST_REQUEST, getZonesListStart);
rootMapReducer.set(FacilityActionType.GET_ZONES_LIST_SUCCESS, getZonesListSuccess);
rootMapReducer.set(FacilityActionType.GET_ZONES_LIST_SUCCESS_NEW, getZonesListSuccessNew);
rootMapReducer.set(FacilityActionType.GET_ZONES_LIST_FAIL, getZonesListFail);

rootMapReducer.set(FacilityActionType.GET_LOGICAL_READERS_REQUEST, getLogicalReadersStart);
rootMapReducer.set(FacilityActionType.GET_LOGICAL_READERS_SUCCESS, getLogicalReadersSuccess);
rootMapReducer.set(FacilityActionType.GET_LOGICAL_READERS_FAIL, getLogicalReadersFail);

rootMapReducer.set(FacilityActionType.DELETE_LOGICAL_READER_REQUEST, deleteLogicalReaderStart);
rootMapReducer.set(FacilityActionType.DELETE_LOGICAL_READER_SUCCESS, deleteLogicalReaderSuccess);
rootMapReducer.set(FacilityActionType.DELETE_LOGICAL_READER_FAIL, deleteLogicalReaderFail);

rootMapReducer.set(FacilityActionType.EDIT_LOGICAL_READER_REQUEST, editLogicalReaderStart);
rootMapReducer.set(FacilityActionType.EDIT_LOGICAL_READER_SUCCESS, editLogicalReaderSuccess);
rootMapReducer.set(FacilityActionType.EDIT_LOGICAL_READER_FAIL, editLogicalReaderFail);

rootMapReducer.set(FacilityActionType.GET_POLYGONS_REQUEST, getPolygonsStart);
rootMapReducer.set(FacilityActionType.GET_POLYGONS_SUCCESS, getPolygonsSuccess);
rootMapReducer.set(FacilityActionType.GET_POLYGONS_FAIL, getPolygonsFail);

rootMapReducer.set(FacilityActionType.DELETE_POLYGON_REQUEST, deletePolygonStart);
rootMapReducer.set(FacilityActionType.DELETE_POLYGON_SUCCESS, deletePolygonSuccess);
rootMapReducer.set(FacilityActionType.DELETE_POLYGON_FAIL, deletePolygonFail);

rootMapReducer.set(FacilityActionType.EDIT_POLYGON_REQUEST, editPolygonStart);
rootMapReducer.set(FacilityActionType.EDIT_POLYGON_SUCCESS, editPolygonSuccess);
rootMapReducer.set(FacilityActionType.EDIT_POLYGON_FAIL, editPolygonFail);

rootMapReducer.set(FacilityActionType.GET_FACILITIES_LIST_REQUEST, getFacilitiesListStart);
rootMapReducer.set(FacilityActionType.GET_FACILITIES_LIST_SUCCESS, getFacilitiesListSuccess);
rootMapReducer.set(FacilityActionType.GET_FACILITIES_LIST_FAIL, getFacilitiesListFail);

rootMapReducer.set(FacilityActionType.GET_GROUP_TYPES_LIST_REQUEST, getGroupTypesListStart);
rootMapReducer.set(FacilityActionType.GET_GROUP_TYPES_LIST_SUCCESS, getGroupTypesListSuccess);
rootMapReducer.set(FacilityActionType.GET_GROUP_TYPES_LIST_FAIL, getGroupTypesListFail);

rootMapReducer.set(FacilityActionType.GET_GROUPS_LIST_REQUEST, getGroupsListStart);
rootMapReducer.set(FacilityActionType.GET_GROUPS_LIST_SUCCESS, getGroupsListSuccess);
rootMapReducer.set(FacilityActionType.GET_GROUPS_LIST_FAIL, getGroupsListFail);

rootMapReducer.set(FacilityActionType.GET_GROUPS_TREE_LIST_REQUEST, getGroupsTreeListStart);
rootMapReducer.set(FacilityActionType.GET_GROUPS_TREE_LIST_SUCCESS, getGroupsTreeListSuccess);
rootMapReducer.set(FacilityActionType.GET_GROUPS_TREE_LIST_FAIL, getGroupsTreeListFail);

rootMapReducer.set(FacilityActionType.RESET_MAP_IMAGE_VALUES, resetImageValues);
rootMapReducer.set(FacilityActionType.RESET_MAP_IMAGE_VALUES_FAIL, resetImageValuesFail);

rootMapReducer.set(FacilityActionType.RESET_MAP_REPORT_VALUES, resetMapReportValues);

rootMapReducer.set(FacilityActionType.EDIT_GROUP_REQUEST, editGroupStart);
rootMapReducer.set(FacilityActionType.EDIT_GROUP_SUCCESS, editGroupSuccess);
rootMapReducer.set(FacilityActionType.EDIT_GROUP_FAIL, editGroupFail);

rootMapReducer.set(FacilityActionType.DELETE_GROUP_REQUEST, deleteGroupStart);
rootMapReducer.set(FacilityActionType.DELETE_GROUP_SUCCESS, deleteGroupSuccess);
rootMapReducer.set(FacilityActionType.DELETE_GROUP_FAIL, deleteGroupFail);

rootMapReducer.set(FacilityActionType.CREATE_ZONE_REQUEST, createZoneRequest);
rootMapReducer.set(FacilityActionType.CREATE_ZONE_SUCCESS, createZoneSuccess);
rootMapReducer.set(FacilityActionType.CREATE_ZONE_FAIL, createZoneFail);

rootMapReducer.set(FacilityActionType.GET_MAPS_ORIGIN_REQUEST, createMapOriginRequest);
rootMapReducer.set(FacilityActionType.GET_MAPS_ORIGIN_SUCCESS, createMapOriginSuccess);
rootMapReducer.set(FacilityActionType.GET_MAPS_ORIGIN_FAIL, createMapOriginFail);

rootMapReducer.set(FacilityActionType.GET_MAPS_IMAGE_REQUEST, createMapImageRequest);
rootMapReducer.set(FacilityActionType.GET_MAPS_IMAGE_SUCCESS, createMapImageSuccess);
rootMapReducer.set(FacilityActionType.GET_MAPS_IMAGE_FAIL, createMapImageFail);

rootMapReducer.set(FacilityActionType.GET_MAPS_IMAGE_IMAGE_REQUEST, createMapImageImageRequest);
rootMapReducer.set(FacilityActionType.GET_MAPS_IMAGE_IMAGE_SUCCESS, createMapImageImageSuccess);
rootMapReducer.set(FacilityActionType.GET_MAPS_IMAGE_IMAGE_FAIL, createMapImageImageFail);

rootMapReducer.set(
  ReportActionType.GET_MAPS_REPORTS_DEFINITION_REQUEST, createMapReportDefinitionRequest,
);
rootMapReducer.set(
  ReportActionType.GET_MAPS_REPORTS_DEFINITION_SUCCESS, createMapReportDefinitionSuccess,
);
rootMapReducer.set(
  ReportActionType.GET_MAPS_REPORTS_DEFINITION_FAIL, createMapReportDefinitionFail,
);

rootMapReducer.set(
  ReportActionType.GET_MAPS_REPORTS_DEFINITION_DEFAULT_REQUEST,
  createMapReportDefinitionDefaultRequest,
);
rootMapReducer.set(
  ReportActionType.GET_MAPS_REPORTS_DEFINITION_DEFAULT_SUCCESS,
  createMapReportDefinitionDefaultSuccess,
);
rootMapReducer.set(
  ReportActionType.GET_MAPS_REPORTS_DEFINITION_DEFAULT_FAIL, createMapReportDefinitionDefaultFail,
);

rootMapReducer.set(ReportActionType.GET_ZONES_LIST_FOR_MAPS_REQUEST, createZoneForMapsRequest);
rootMapReducer.set(ReportActionType.GET_ZONES_FOR_MAPS_LIST_SUCCESS, createZoneForMapsSuccess);
rootMapReducer.set(ReportActionType.GET_ZONES_FOR_MAPS_LIST_FAIL, createZoneForMapsFail);

rootMapReducer.set(ReportActionType.GET_MAP_REPORT_REQUEST, createMapReportRequest);
rootMapReducer.set(ReportActionType.GET_MAP_REPORT_SUCCESS, createMapReportSuccess);
rootMapReducer.set(ReportActionType.GET_MAP_REPORT_FAIL, createMapReportFail);

rootMapReducer.set(AssetActionType.GET_ASSET_TYPES_LIST_REQUEST, getAssetTypesListStart);
rootMapReducer.set(AssetActionType.GET_ASSET_TYPES_LIST_SUCCESS, getAssetTypesListSuccess);
rootMapReducer.set(AssetActionType.GET_ASSET_TYPES_LIST_FAIL, getAssetTypesListFail);

rootMapReducer.set(AssetActionType.GET_ASSET_TYPE_REQUEST, getAssetTypeStart);
rootMapReducer.set(AssetActionType.GET_ASSET_TYPE_SUCCESS, getAssetTypeSuccess);
rootMapReducer.set(AssetActionType.GET_ASSET_TYPE_FAIL, getAssetTypeFail);

rootMapReducer.set(AssetActionType.EDIT_ASSET_TYPE_REQUEST, editAssetStart);
rootMapReducer.set(AssetActionType.EDIT_ASSET_TYPE_SUCCESS, editAssetSuccess);
rootMapReducer.set(AssetActionType.EDIT_ASSET_TYPE_FAIL, editAssetFail);

rootMapReducer.set(AssetActionType.GET_ASSET_TYPE_PROPERTIES_REQUEST, getAssetTypePropertiesStart);
rootMapReducer.set(
  AssetActionType.GET_ASSET_TYPE_PROPERTIES_SUCCESS, getAssetTypePropertiesSuccess,
);
rootMapReducer.set(AssetActionType.GET_ASSET_TYPE_PROPERTIES_FAIL, getAssetTypePropertiesFail);
rootMapReducer.set(AssetActionType.ADD_ASSET_TYPE_PROPERTY_REQUEST, addAssetTypePropertyStart);
rootMapReducer.set(AssetActionType.ADD_ASSET_TYPE_PROPERTY_SUCCESS, addAssetTypePropertySuccess);
rootMapReducer.set(AssetActionType.ADD_ASSET_TYPE_PROPERTY_FAIL, addAssetTypePropertyFail);
rootMapReducer.set(AssetActionType.EDIT_ASSET_TYPE_PROPERTY_REQUEST, editAssetTypePropertyStart);
rootMapReducer.set(AssetActionType.EDIT_ASSET_TYPE_PROPERTY_SUCCESS, editAssetTypePropertySuccess);
rootMapReducer.set(AssetActionType.EDIT_ASSET_TYPE_PROPERTY_FAIL, editAssetTypePropertyFail);
rootMapReducer.set(
  AssetActionType.DELETE_ASSET_TYPE_PROPERTY_REQUEST, deleteAssetTypePropertyStart,
);
rootMapReducer.set(
  AssetActionType.DELETE_ASSET_TYPE_PROPERTY_SUCCESS, deleteAssetTypePropertySuccess,
);
rootMapReducer.set(AssetActionType.DELETE_ASSET_TYPE_PROPERTY_FAIL, deleteAssetTypePropertyFail);

rootMapReducer.set(ReportActionType.GET_REPORTS_TREE_REQUEST, getReportsListRequest);
rootMapReducer.set(ReportActionType.GET_REPORTS_TREE_SUCCESS, getReportsListSuccess);
rootMapReducer.set(ReportActionType.GET_REPORTS_TREE_FAIL, getReportsListFail);

rootMapReducer.set(ReportActionType.GET_REPORTS_REQUEST, getReportsRequest);
rootMapReducer.set(ReportActionType.GET_REPORTS_SUCCESS, getReportsSuccess);
rootMapReducer.set(ReportActionType.GET_REPORTS_FAIL, getReportsFail);

rootMapReducer.set(ReportActionType.PREPARE_EXPORT_REPORT_REQUEST, prepareReportRequest);
rootMapReducer.set(ReportActionType.PREPARE_EXPORT_REPORT_SUCCESS, prepareReportSuccess);
rootMapReducer.set(ReportActionType.PREPARE_EXPORT_REPORT_FAIL, prepareReportFailure);

rootMapReducer.set(ReportActionType.COPY_REPORT_FAIL, copyReportFailure);

rootMapReducer.set(ReportActionType.GET_REPORT_REQUEST, getReportRequest);
rootMapReducer.set(ReportActionType.GET_REPORT_SUCCESS, getReportSuccess);
rootMapReducer.set(ReportActionType.GET_REPORT_FAIL, getReportFail);

rootMapReducer.set(ReportActionType.GET_EXECUTED_REPORT_REQUEST, getExecutedReportRequest);
rootMapReducer.set(ReportActionType.GET_EXECUTED_REPORT_SUCCESS, getExecutedReportSuccess);
rootMapReducer.set(ReportActionType.GET_EXECUTED_REPORT_FAIL, getExecutedReportFail);
rootMapReducer.set(ReportActionType.RESET_EXECUTED_REPORT, resetExecutedReport);

rootMapReducer.set(ReportActionType.GET_ALL_REPORT_COLUMNS_REQUEST, getAllColumnsReportRequest);
rootMapReducer.set(ReportActionType.GET_ALL_REPORT_COLUMNS_SUCCESS, getAllColumnsReportSuccess);
rootMapReducer.set(ReportActionType.GET_ALL_REPORT_COLUMNS_FAIL, getAllColumnsReportFail);

rootMapReducer.set(
  ReportActionType.GET_COLLECTIONS_FOR_REPORT_REQUEST,
  getCollectionsForReportRequest,
);
rootMapReducer.set(
  ReportActionType.GET_COLLECTIONS_FOR_REPORT_SUCCESS,
  getCollectionsForReportSuccess,
);
rootMapReducer.set(
  ReportActionType.GET_COLLECTIONS_FOR_REPORT_FAIL,
  getCollectionsForReportFail,
);

rootMapReducer.set(ReportActionType.EXECUTE_REPORT_REQUEST, executeReportRequest);
rootMapReducer.set(ReportActionType.EXECUTE_REPORT_SUCCESS, executeReportSuccess);
rootMapReducer.set(ReportActionType.EXECUTE_REPORT_FAIL, executeReportFail);

rootMapReducer.set(ReportActionType.DELETE_COLUMN_REQUEST, removeColumnRequest);
rootMapReducer.set(ReportActionType.DELETE_COLUMN_SUCCESS, removeColumnSuccess);
rootMapReducer.set(ReportActionType.DELETE_COLUMN_FAIL, removeColumnFail);

rootMapReducer.set(DevicesActionType.GET_DEVICES_LIST_REQUEST, getDevicesListRequest);
rootMapReducer.set(DevicesActionType.GET_DEVICES_LIST_SUCCESS, getDevicesListSuccess);
rootMapReducer.set(DevicesActionType.GET_DEVICES_LIST_FAIL, getDevicesListFail);

rootMapReducer.set(ReportActionType.GET_REGEX_REQUEST, getRegexRequest);
rootMapReducer.set(ReportActionType.GET_REGEX_SUCCESS, getRegexSuccess);
rootMapReducer.set(ReportActionType.GET_REGEX_FAIL, getRegexFail);

rootMapReducer.set(UserActionType.LOGOUT_SUCCESS, logoutSuccess);

rootMapReducer.set(ReportActionType.GET_REPORT_QUICK_RANGES_REQUEST, getReportQuickRangesRequest);
rootMapReducer.set(ReportActionType.GET_REPORT_QUICK_RANGES_SUCCESS, getReportQuickRangesSuccess);
rootMapReducer.set(ReportActionType.GET_REPORT_QUICK_RANGES_FAIL, getReportQuickRangesFail);

rootMapReducer.set(ReportActionType.GET_LISTS_FOR_REPORT_REQUEST, getListsForReportRequest);
rootMapReducer.set(ReportActionType.GET_LISTS_FOR_REPORT_SUCCESS, getListsForReportSuccess);
rootMapReducer.set(ReportActionType.GET_LISTS_FOR_REPORT_FAIL, getListsForReportFail);

rootMapReducer.set(ReportActionType.GET_REPORT_SUGGESTIONS_REQUEST, getReportSuggestionsRequest);
rootMapReducer.set(ReportActionType.GET_REPORT_SUGGESTIONS_SUCCESS, getReportSuggestionsSuccess);
rootMapReducer.set(ReportActionType.GET_REPORT_SUGGESTIONS_FAIL, getReportSuggestionsFail);

rootMapReducer.set(ReportActionType.MAP_CONTROLS_STATE, updateMapControsState);
rootMapReducer.set(ReportActionType.MAP_CONTROLS_STATE_FAIL, updateMapControsStateFail);

rootMapReducer.set(TenantActionType.GET_TENANT_RULES_REQUEST, tenantRulesConfigRequest);
rootMapReducer.set(TenantActionType.GET_TENANT_RULES_SUCCESS, tenantRulesConfigSuccess);
rootMapReducer.set(TenantActionType.GET_TENANT_RULES_FAIL, tenantRulesConfigFail);
rootMapReducer.set(
  TenantActionType.GET_TENANT_RULES_SCHEMA_REQUEST, tenantRulesConfigSchemaRequest,
);
rootMapReducer.set(
  TenantActionType.GET_TENANT_RULES_SCHEMA_SUCCESS, tenantRulesConfigSchemaSuccess,
);
rootMapReducer.set(TenantActionType.GET_RULES_CONFIG_SUCCESS, rulesConfigSuccess);

rootMapReducer.set(TenantActionType.GET_TENANT_RULES_SCHEMA_FAIL, tenantRulesConfigSchemaFail);

rootMapReducer.set(TenantActionType.GET_RULES_FIELDS_REQUEST, rulesConfigSchemaRequest);
rootMapReducer.set(TenantActionType.GET_RULES_FIELDS_SUCCESS, rulesConfigSchemaSuccess);
rootMapReducer.set(TenantActionType.GET_RULES_FIELDS_FAIL, rulesConfigSchemaFail);

rootMapReducer.set(TenantActionType.GET_RULES_PSEUDOCODE_REQUEST, rulesPseudoCodeRequest);
rootMapReducer.set(TenantActionType.GET_RULES_PSEUDOCODE_SUCCESS, rulesPseudoCodeSuccess);
rootMapReducer.set(TenantActionType.GET_RULES_PSEUDOCODE_FAIL, rulesPseudoCodeFail);

rootMapReducer.set(TenantActionType.TENANT_RULES_CONFIG_SAVE_REQUEST, tenantRulesConfigSaveRequest);
rootMapReducer.set(TenantActionType.TENANT_RULES_CONFIG_SAVE_SUCCESS, tenantRulesConfigSaveSuccess);
rootMapReducer.set(TenantActionType.TENANT_RULES_CONFIG_SAVE_FAIL, tenantRulesConfigSaveFail);

rootMapReducer.set(TenantActionType.RULES_CONFIG_SAVE_REQUEST, rulesConfigSaveRequest);
rootMapReducer.set(TenantActionType.RULES_CONFIG_SAVE_SUCCESS, rulesConfigSaveSuccess);
rootMapReducer.set(TenantActionType.RULES_CONFIG_SAVE_FAIL, rulesConfigSaveFail);

rootMapReducer.set(TenantActionType.ZONES_SAVE_REQUEST, zonesSaveRequest);
rootMapReducer.set(TenantActionType.ZONES_SAVE_SUCCESS, zonesSaveSuccess);
rootMapReducer.set(TenantActionType.ZONES_SAVE_FAIL, zonesSaveFail);

rootMapReducer.set(TenantActionType.GET_MERMAID_DIAGRAM_REQUEST, tenantMermaidDiagramRequest);
rootMapReducer.set(TenantActionType.GET_MERMAID_DIAGRAM_SUCCESS, tenantMermaidDiagramSuccess);
rootMapReducer.set(TenantActionType.GET_MERMAID_DIAGRAM_FAIL, tenantMermaidDiagramFail);

rootMapReducer.set(RuleActionType.GET_RULES_AND_STATEMENTS_REQUEST, getRulesAndStatementsRequest);
rootMapReducer.set(RuleActionType.GET_RULES_AND_STATEMENTS_SUCCESS, getRulesAndStatementsSuccess);
rootMapReducer.set(RuleActionType.GET_RULES_AND_STATEMENTS_FAIL, getRulesAndStatementsFail);

rootMapReducer.set(
  RuleActionType.GET_TRANSFORMS_AND_STATEMENTS_REQUEST, getTransformsAndStatementsRequest,
);
rootMapReducer.set(
  RuleActionType.GET_TRANSFORMS_AND_STATEMENTS_SUCCESS, getTransformsAndStatementsSuccess,
);
rootMapReducer.set(
  RuleActionType.GET_TRANSFORMS_AND_STATEMENTS_FAIL, getTransformsAndStatementsFail,
);

rootMapReducer.set(
  RuleActionType.GET_SYSTEMCONFIG_AND_STATEMENTS_REQUEST, getSystemConfigAndStatementsRequest,
);
rootMapReducer.set(
  RuleActionType.GET_SYSTEMCONFIG_AND_STATEMENTS_SUCCESS, getSystemConfigAndStatementsSuccess,
);
rootMapReducer.set(
  RuleActionType.GET_SYSTEMCONFIG_AND_STATEMENTS_FAIL, getSystemConfigAndStatementsFail,
);

rootMapReducer.set(RuleActionType.GET_SCHEDULEDRULES_REQUEST, getScheduleRulesRequest);
rootMapReducer.set(RuleActionType.GET_SCHEDULEDRULES_SUCCESS, getScheduleRulesSuccess);
rootMapReducer.set(RuleActionType.GET_SCHEDULEDRULES_FAIL, getScheduleRulesFail);

rootMapReducer.set(RuleActionType.UPDATE_RULES_REQUEST, updateRulesRequest);
rootMapReducer.set(RuleActionType.UPDATE_RULES_SUCCESS, updateRulesSuccess);
rootMapReducer.set(RuleActionType.UPDATE_RULES_FAIL, updateRulesFail);

rootMapReducer.set(RuleActionType.UPDATE_TRANSFORMS_REQUEST, updateTransformsRequest);
rootMapReducer.set(RuleActionType.UPDATE_RULES_SUCCESS, updateTransformsSuccess);
rootMapReducer.set(RuleActionType.UPDATE_TRANSFORMS_FAIL, updateTransformsFail);

rootMapReducer.set(RuleActionType.UPDATE_SYSTEMCONFIG_REQUEST, updateSystemConfigRequest);
rootMapReducer.set(RuleActionType.UPDATE_SYSTEMCONFIG_SUCCESS, updateSystemConfigSuccess);
rootMapReducer.set(RuleActionType.UPDATE_SYSTEMCONFIG_FAIL, updateSystemConfigFail);

rootMapReducer.set(RuleActionType.UPDATE_SCHEDULEDRULES_REQUEST, updateScheduledRulesRequest);
rootMapReducer.set(RuleActionType.UPDATE_SCHEDULEDRULES_SUCCESS, updateScheduledRulesSuccess);
rootMapReducer.set(RuleActionType.UPDATE_SCHEDULEDRULES_FAIL, updateScheduledRulesFail);

export const helpRequest = (state: IState): IState => ({
  ...state,
  help: {
    data: {
      url: null,
    },
    loading: true,
    error: undefined,
    displayed: false,
  },
});

export const helpSuccess = (state: IState, action: IAction<IHelp>): IState => ({
  ...state,
  help: {
    data: action.payload,
    loading: false,
    error: undefined,
    displayed: true,
  },
});

export const helpFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  help: {
    data: {
      url: null,
    },
    loading: false,
    error: action.payload,
    displayed: false,
  },
});

export const toggleHelp = (state: IState): IState => ({
  ...state,
  help: {
    ...state.help,
    displayed: !state.help.displayed,
  },
});

rootMapReducer.set(HelpActionType.GET_HELP_REQUEST, helpRequest);
rootMapReducer.set(HelpActionType.GET_HELP_SUCCESS, helpSuccess);
rootMapReducer.set(HelpActionType.GET_HELP_FAIL, helpFail);
rootMapReducer.set(HelpActionType.TOGGLE_HELP, toggleHelp);

rootMapReducer.set(
  UserActionType.CHANGE_FORGOTTEN_PASSWORD_REQUEST,
  changeForgottenPasswordRequest,
);
rootMapReducer.set(
  UserActionType.CHANGE_FORGOTTEN_PASSWORD_SUCCESS,
  changeForgottenPasswordSuccess,
);
rootMapReducer.set(
  UserActionType.CHANGE_FORGOTTEN_PASSWORD_FAIL,
  changeForgottenPasswordFail,
);

export default createReducerUtil<IState, IAction>(
  (action: IAction): AppReducer => rootMapReducer.get(action.type) as AppReducer,
);
